// Generated by i18n
import { registerLazyTranslations } from '@bluecodecom/i18n';

registerLazyTranslations('virtual-terminal.translation', (lng) =>
  import(
    /* webpackChunkName: "i18n-virtual-terminal-translation-[request]" */
    `./${lng}`
  ).then((m) => m.default),
);

export type VirtualTerminalTranslationTranslationsType = typeof import('./en').default;
